import React, { useState } from 'react';
import useIsMobile from '@dapp/multi-lib/ui/shared-hooks/useIsMobile';
import { HeaderCommonDesktop } from './HeaderCommon/HeaderCommonDesktop';
import { HeaderCommonMobile } from './HeaderCommon/HeaderCommonMobile';
import { HeaderCommonMobileModal } from './HeaderCommon/HeaderCommonMobileModal';

interface HeaderCommonProps {
  isBannerClosed?: boolean;
}

export const HeaderCommon = ({ isBannerClosed }: HeaderCommonProps) => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setOpen(open);
  };
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <>
        <div className='z-20 flex w-full flex-row items-center justify-between px-1'>
          <HeaderCommonMobile open={open} onOpenChange={handleOpenChange} />
          <HeaderCommonMobileModal
            open={open}
            onOpenChange={handleOpenChange}
          />
        </div>
      </>
    );
  }
  return <HeaderCommonDesktop isBannerClosed={isBannerClosed} />;
};
